import { IN_WEEK_DAY_DICTIONARY } from '../../constants/weekDays';
import { isToday, isTomorrow } from '../date';
import { formatDisplayTime, getTimeFromDate, parseStringToDate } from '../time';
export var getSuccessCallbackMessage = function getSuccessCallbackMessage(date, timezoneDiff) {
  var newbuildingName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var callbackDate = parseStringToDate(date, timezoneDiff);
  var callTime = formatDisplayTime(getTimeFromDate(callbackDate));
  var displayNewbuilding = newbuildingName ? "\u0438\u0437 \u0416\u041A ".concat(newbuildingName, " ") : '';

  switch (true) {
    case isToday(callbackDate):
      return "\u0417\u0430\u0441\u0442\u0440\u043E\u0439\u0449\u0438\u043A ".concat(displayNewbuilding, "\u043F\u0435\u0440\u0435\u0437\u0432\u043E\u043D\u0438\u0442\xA0\u0432\u0430\u043C \n\u0441\u0435\u0433\u043E\u0434\u043D\u044F \u0432 ").concat(callTime);

    case isTomorrow(callbackDate):
      return "\u0417\u0430\u0441\u0442\u0440\u043E\u0439\u0449\u0438\u043A ".concat(displayNewbuilding, "\u043F\u0435\u0440\u0435\u0437\u0432\u043E\u043D\u0438\u0442\xA0\u0432\u0430\u043C \n\u0437\u0430\u0432\u0442\u0440\u0430 \u0432 ").concat(callTime);

    default:
      {
        var inWeekDay = IN_WEEK_DAY_DICTIONARY[callbackDate.getDay()];
        return "\u0417\u0430\u0441\u0442\u0440\u043E\u0439\u0449\u0438\u043A ".concat(displayNewbuilding, "\u043F\u0435\u0440\u0435\u0437\u0432\u043E\u043D\u0438\u0442\xA0\u0432\u0430\u043C \n").concat(inWeekDay, " \u0432 ").concat(callTime);
      }
  }
};